import React, { Component } from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoLinkedin, BiLogoInstagram, BiMobile } from 'react-icons/bi';

const KontaktInfo = () => {
    const { t } = useTranslations();
    return (
        <div className="contact-info">
            <div className="contact-info-content">
                <h3>{t('contact_info_title')}</h3>

                <h2>
                    <a href="mailto:Info@simplify-data.de" className="email">Info@simplify-data.de</a>
                </h2>
                {t('contact_info_alternative')}
                <ul className="social">
                    <li>
                        <Link href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank" title='LinkedIn'>
                            <BiLogoLinkedin />
                        </Link>
                    </li>
                    <li>
                        <Link href="https://www.instagram.com/simplify.data/" target="_blank" title='Instagram'>
                            <BiLogoInstagram />
                        </Link>
                    </li>
                    <li>
                        <Link href="tel://+4943170577024" target="_blank" title='Telefon'>
                            <BiMobile />
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );

}

export default KontaktInfo;